import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Field, RuleExpression } from "vee-validate";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationProvider',
  props: {
  rules: {
    type: [Object, String, Function] as PropType<RuleExpression<unknown>>,
    default: ""
  },
  name: {
    type: String,
    required: true
  },
  vid: {
    type: String,
    default: ""
  },
  tag: {
    type: String,
    default: "div"
  }
},
  setup(__props) {

// NOTE: このコンポーネントは vee-validate v3 で書かれたコードをカバーするために作成したものです。
// 新規でフォームを用意する場合は、原則 ValidationField (plugins 内で定義した vee-validate のコンポーネント) を利用してください。


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Field), {
    name: __props.vid || __props.name,
    rules: __props.rules,
    label: __props.name,
    as: __props.tag
  }, {
    default: _withCtx(({ errors, value, handleChange, handleBlur, meta }) => [
      _renderSlot(_ctx.$slots, "default", {
        errors: errors,
        value: value,
        meta: meta,
        handleChange: handleChange,
        handleBlur: handleBlur
      })
    ]),
    _: 3
  }, 8, ["name", "rules", "label", "as"]))
}
}

})